module.exports = __webpack_public_path__ + "static/media/VAT-Overview.2b602a4b.png";